import { trackClientEvent } from './analytics'

type OptimizelyEvent = {
  optimizelyEventId?: string,
  optimizelyEventKey?: string,
}

export function trackCruisesClickEvent(subject: string, optimizelyEvent?: OptimizelyEvent) {
  trackClientEvent({
    subject,
    action: 'clicked',
    category: 'cruise',
    type: 'interaction',
    ...optimizelyEvent,
  })
}
